import {STreeItem} from "@/components/dto/STreeItem";
import {Vue} from "vue-property-decorator";
import {SPropTypeEnum} from "@/components/dto/SPropTypeEnum";
import {v4 as uuid_v4} from "uuid";

export interface RTreeServices{
    findRemoveItem(parrentItem: STreeItem[], itemId:string): STreeItem[];
    updateAllChildrenOpened(open: boolean, children: STreeItem[]): void;
    updateAllChildrenGenerated(allGenerated: boolean, children: STreeItem[]): void;
    setLastGeneratedAllItems(items: STreeItem[], all: boolean): void;
    updateParentGenerated(allGenerated: boolean, parent: Vue): void;
    updateValue(data: STreeItem): void;
    updateParentValue(parent: Vue): void;
    updateChildrenString(allGenerated: boolean, children: STreeItem[]): void;
    refreshUUIDAllChildren(data: STreeItem[]):void;
}

export class RTreeServicesImpl implements RTreeServices{
    findRemoveItem(parrentItem: STreeItem[], itemId:string): STreeItem[]{
        parrentItem.map(item => {
            if(item.itemId === itemId){
                const index = parrentItem.indexOf(item, 0);
                if (index > -1) {
                    parrentItem.splice(index, 1);
                }
                return parrentItem;
            }
            if(item.propChildren.length > 0){
                return this.findRemoveItem(item.propChildren, itemId);
            }else {
                return [];
            }
        });
        return parrentItem;
    }
    updateAllChildrenOpened(open: boolean, children: STreeItem[]){
        children.map(i => {
            i.isOpen = open;
            this.updateAllChildrenOpened(open, i.propChildren);
        })
    }
    updateAllChildrenGenerated(allGenerated: boolean, children: STreeItem[]){
        children.map(i => {
            i.allGenerated = allGenerated;
            this.updateAllChildrenGenerated(allGenerated, i.propChildren);
        })
    }
    setLastGeneratedAllItems(items: STreeItem[], all: boolean){
        items.map(i => {
            i.isLastItem = false;
            const filtered: STreeItem[] = items.filter(i => i.allGenerated);
            items.map(i => {
                if(filtered.length > 0 && filtered[filtered.length -1].itemId === i.itemId){
                    i.isLastItem = true;
                }
            });
            if(all) {
                this.setLastGeneratedAllItems(i.propChildren, all);
            }
        });

    }
    updateParentGenerated(allGenerated: boolean, parent: Vue){
        if(parent){
            if(parent.$props === undefined){ return;}
            if(parent.$props.item){
                let updateData: boolean = false;
                parent.$parent.$children.map(i => {
                    const ch: any = i;
                    if(ch && ch.item){
                        if(ch.item.propChildren.find((i: any) => i.allGenerated) || ch.item.propType === SPropTypeEnum.SARRAY){
                            updateData = true;
                        }
                    }
                });
                if(!updateData || allGenerated) {
                    parent.$props.item.allGenerated = allGenerated;
                }
            }
            if(parent.$parent){
                this.updateParentGenerated(allGenerated, parent.$parent);
            }
        }
    }
    updateValue(data : STreeItem){
        if(data.propType === SPropTypeEnum.SARRAY){
            let dataArray: any = [];
            if(data.allGenerated) {
                data.propChildren.map((item: STreeItem) => {
                    let dataObjArray: any = [];
                    let dataObj: { [k: string]: any } = {};
                    if(item.allGenerated){
                        item.propChildren.map((i: STreeItem) => {
                            if(i.allGenerated){
                                if (i.propType === SPropTypeEnum.SSTRING || i.propType === SPropTypeEnum.SNULL ||
                                    i.propType === SPropTypeEnum.SNUMBER || i.propType === SPropTypeEnum.SBOOLEAN) {
                                    dataObj[i.propName] = i.propValue;
                                }else {
                                    dataObj[i.propName] = this.updateValue(i);
                                }
                            }
                        });
                        if(item.propChildren.length === 0){
                            dataObjArray.push(item.propValue);
                        }
                    }else if(item.propOutputType === SPropTypeEnum.SSTRING && item.allGenerated) {
                        dataObjArray.push(item.propValue);
                    }else{
                        dataObjArray = [];
                    }
                    if (item.propChildren.length > 0 && item.allGenerated) {
                        dataObjArray.push(dataObj);
                    }
                    if(dataObjArray.length > 0){
                        dataArray.push(...dataObjArray);
                    }
                });
            }else {
                dataArray = [];
            }
            if(data.propOutputType === SPropTypeEnum.SSTRING){
                return JSON.stringify(dataArray);
            }else {
                return dataArray;
            }
        }else{
            let dataObj: {[k: string]: any} = {};
            if(data.allGenerated) {
                data.propChildren.map((item: STreeItem) => {
                    if (item.allGenerated) {
                        if (item.propType === SPropTypeEnum.SSTRING ||
                            item.propType === SPropTypeEnum.SNUMBER || item.propType === SPropTypeEnum.SBOOLEAN) {
                            dataObj[item.propName] = item.propValue;
                        }else if(item.propType === SPropTypeEnum.SNULL){
                            if(data.propOutputType === SPropTypeEnum.SSTRING){
                                dataObj[item.propName] = null;
                            }else {
                                dataObj[item.propName] = item.propValue;
                            }
                        }
                        else {
                            dataObj[item.propName] = this.updateValue(item);
                        }
                    }
                });
            }
            if(data.propOutputType === SPropTypeEnum.SSTRING){
                if(data.allGenerated){
                    if(data.propChildren.length > 0) {
                        return JSON.stringify(dataObj);
                    }else {
                        return data.propValue;
                    }
                }else{
                    return "";
                }
            }else {
                if(data.propChildren.length > 0) {
                    return dataObj;
                }else {
                    return data.propValue;
                }
            }
        }
    }
    updateParentValue(parent: Vue){
        if(parent){
            if(parent.$props === undefined){ return;}
            if(parent.$props.item && parent.$props.item.propOutputType === SPropTypeEnum.SSTRING){
                parent.$props.item.propOutputValue = this.updateValue(parent.$props.item);
            }
            if(parent.$parent){
                this.updateParentValue(parent.$parent);
            }
        }
    }
    updateChildrenString(allGenerated: boolean, children: STreeItem[]){
        children.map(i => {
            i.propOutputValue = this.updateValue(i);
            if(!allGenerated){
                i.propOutputValue = '';
            }
        })
    }
    refreshUUIDAllChildren(data: STreeItem[]){
        data.map(i => {
            i.itemId = uuid_v4();
            this.refreshUUIDAllChildren(i.propChildren);
        })
    }
}
